import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BannerAppComponent } from '../banner-app/banner-app.component';
import { FooterAppComponent } from '../footer-app/footer-app.component';
import { REDIRECT } from '../../routes.constans';
import { TrackingService } from '../../services/tracking.service';

@Component({
  selector: 'app-poliza-activa',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent],
  templateUrl: './poliza-activa.component.html',
  styleUrls: ['./poliza-activa.component.scss'],
})
export class PolizaActivaComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly trackingService = inject(TrackingService);

  private codAsesor?: string;

  ngOnInit(): void {
    this.trackingService.enviarEventoYaTienesUnaPolizaActiva(
      'ya_tienes_una_poliza_activa',
      'Pageview'
    );
    this.codAsesor = this.route.snapshot.queryParams['codigoAsesor'];
  }

  volverAlInicio(): void {
    this.trackingService.enviarEventoYaTienesUnaPolizaActiva(
      'ya_tienes_una_poliza_activa',
      'Button',
      'Volver al Inicio'
    );
    const queryParams = this.codAsesor ? { codigoAsesor: this.codAsesor } : {};
    this.router.navigate([REDIRECT], { queryParams });
  }
}
